import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";

// Tabella obiettivi per area
function AreaTargetsTable({ targets, areas, onUpdate }) {
  const [editTargets, setEditTargets] = useState([]);
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    if (targets && targets.length > 0) {
      setEditTargets(targets.map((t) => ({ ...t })));
      setChanged(false);
    } else if (areas && areas.length > 0) {
      setEditTargets(
        areas.map((a) => ({
        area_id: a.id,
        target: 0
        }))
      );
      setChanged(false);
    } else {
      setEditTargets([]);
      setChanged(false);
    }
  }, [targets, areas]);



  function handleInput(area_id, value) {
    setEditTargets(
      editTargets.map((t) =>
        t.area_id === area_id ? { ...t, target: Number(value) || 0 } : t
      )
    );
    setChanged(true);
  }

  async function handleSave() {
    try {
      await onUpdate(editTargets);
      setChanged(false);
    } catch (err) {
      alert("Errore salvataggio obiettivi");
    }
  }

  if (!editTargets || editTargets.length === 0)
    return <p className="text-muted">Caricamento aree...</p>;

  return (
    <table className="table table-bordered mb-3">
      <thead className="table-light">
        <tr>
          <th>Area</th>
          <th style={{ width: "150px" }}>Obiettivo</th>
        </tr>
      </thead>
      <tbody>
        {editTargets.map((t) => (
          <tr key={t.area_id}>
            <td>
              {(areas.find((a) => a.id === t.area_id)?.name) || t.area}
            </td>
            <td>
              <input
                type="number"
                value={t.target || 0}
                onChange={(e) => handleInput(t.area_id, e.target.value)}
                className="form-control"
                min={0}
                readOnly={false}
              />
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={2}>
            <button
              className="btn btn-primary btn-sm"
              onClick={handleSave}
              disabled={!changed}
            >
              {changed ? "Salva obiettivi area" : "Nessuna modifica"}
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  );
}

function EventDetails({ user }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const { id: eventId } = useParams();

  const [event, setEvent] = useState(undefined);
  const [clients, setClients] = useState([]);
  const [areas, setAreas] = useState([]);
  const [targets, setTargets] = useState([]);
  const [newClient, setNewClient] = useState({
    first_name: "",
    last_name: "",
    company_name: "",
    email: "",
    area: ""
  });


  const [editingRows, setEditingRows] = useState({});
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [showTargets, setShowTargets] = useState(false);

  const [editedEvent, setEditedEvent] = useState({});
  const [eventChanged, setEventChanged] = useState(false);


  // 1. Carica evento per id
  useEffect(() => {
    setLoading(true);
    setErr(null);
    api.getEvents()
      .then(res => {
        if (res.success && Array.isArray(res.events)) {
          const found = res.events.find(ev => String(ev.id) === String(id));
          if (found) setEvent(found);
          else setErr("Evento non trovato");
        } else {
          setErr("Errore caricamento evento");
        }
      })
      .catch(() => setErr("Errore di connessione"))
      .finally(() => setLoading(false));
  }, [id]);

  // 2. Carica risorse SOLO quando event pronto
  useEffect(() => {
    if (!event) return;
    loadClients();
    loadAreas();
    loadTargets();
    // eslint-disable-next-line
  }, [event]);

  useEffect(() => {
    if (event) {
      setEditedEvent({
        event_name: event.event_name,
        event_date: event.event_date,
        target_participants: event.target_participants
      });
      setEventChanged(false);
    }
  }, [event]);


  function handleEventChange(field, value) {
    setEditedEvent({
      ...editedEvent,
      [field]: value
    });
    setEventChanged(true);
  }



  async function handleSaveEvent() {
    try {
      const res = await api.updateEvent(eventId, editedEvent);
      if (res.success) {
        setEvent({ ...event, ...editedEvent });
        setEventChanged(false);
        alert('Evento aggiornato');
        loadEvent();
      } else {
        alert('Errore: ' + (res.error || 'Unknown'));
      }
    } catch (err) {
      alert('Errore salvataggio: ' + err.message);
    }
  }

  async function loadEvent() {
  try {
    const res = await api.getEvents();
    if (res.success) {
      const currentEvent = res.events.find(e => e.id === parseInt(eventId));
      if (currentEvent) {
        setEvent(currentEvent);
        setEditedEvent({
          event_name: currentEvent.event_name,
          event_date: currentEvent.event_date,
          target_participants: currentEvent.target_participants
        });
      }
    }
  } catch (err) {
    console.error('Error loading event:', err);
  }
}


  async function loadClients() {
    try {
      const res = await api.getClientsByEvent(event.id);
      if (res.success) setClients(res.clients);
    } catch (err) { }
  }
  
  async function loadAreas() {
    try {
      const res = await api.getAreas();
      if (res.success) setAreas(res.areas);
    } catch (err) { }
  }
  
  async function loadTargets() {
    try {
      const res = await api.getEventAreaTargets(event.id);
      if (res.success) setTargets(res.targets);
    } catch (err) { }
  }

  function handleInputChange(e) {
    setNewClient({
      ...newClient,
      [e.target.name]: e.target.value,
    });
  }

  async function handleAddClient(e) {
    e.preventDefault();
    
    if (!user || !user.id) {
      alert("Errore: ID utente non disponibile. Rifare login.");
      console.error('❌ user object:', user);
      return;
    }
    
    try {
      const added = await api.createClient(newClient);
      
      if (added.success) {
        const assignPayload = {
          event_id: event.id,
          client_id: added.client_id,
          area_manager_id: user.id
        };
        
        const assignRes = await api.assignClient(assignPayload);
        
        if (assignRes.success) {
          await loadClients();
          setNewClient({
            first_name: "",
            last_name: "",
            company_name: "",
            email: "",
            area: "",
          });
        } else {
          alert(assignRes.error || "Errore assegnazione cliente");
        }
      } else {
        alert(added.error || "Errore aggiunta cliente");
      }
    } catch (err) {
      console.error('❌ handleAddClient error:', err);
      alert("Errore di connessione");
    }
  }

  function handleEditChange(clientId, field, value) {
    setEditingRows({
      ...editingRows,
      [clientId]: {
        ...editingRows[clientId],
        [field]: value,
      },
    });
  }

  function isRowChanged(client) {
    const edited = editingRows[client.id];
    if (!edited) return false;
    return (
      (edited.first_name !== undefined && edited.first_name !== client.first_name) ||
      (edited.last_name !== undefined && edited.last_name !== client.last_name) ||
      (edited.company_name !== undefined && edited.company_name !== client.company_name) ||
      (edited.email !== undefined && edited.email !== client.email) ||
      (edited.area !== undefined && edited.area !== client.area) ||
      (edited.status !== undefined && edited.status !== client.status)
    );
  }

  async function handleRowSave(clientId) {
    const edited = editingRows[clientId];
    if (!edited) return;
    try {
      if (
        edited.status !== undefined &&
        Object.keys(edited).length === 1
      ) {
        const res = await api.updateClientStatus(event.id, clientId, edited.status);
        if (res.success) {
          await loadClients();
          setEditingRows({ ...editingRows, [clientId]: {} });
        } else {
          alert("Errore salvataggio stato");
        }
      } else {
        const res = await api.updateClient({
          client_id: clientId,
          ...edited,
        });
        if (res.success) {
          await loadClients();
          setEditingRows({ ...editingRows, [clientId]: {} });
        } else {
          alert("Errore salvataggio modifica");
        }
      }
    } catch (err) {
      alert("Errore di connessione");
    }
  }

  async function handleDeleteClient(clientId) {
    if (!window.confirm("Eliminare davvero questo cliente dall'evento?")) return;
    try {
      const res = await api.deleteParticipation(event.id, clientId);
      if (res.success) await loadClients();
      else alert("Errore eliminazione partecipazione");
    } catch (err) {
      alert("Errore eliminazione partecipazione");
    }
  }

  // Statistiche
  const areaCounts = areas.map((area) => {
    const targetObj = targets.find((t) => t.area_id === area.id);
    return {
      name: area.name,
      target: targetObj ? targetObj.target : 0,
      actual: clients.filter((c) => c.area === area.name).length,
    };
  });

  const confirmedCount = clients.filter((c) => c.status === "confirmed").length;
  const totalTarget = targets.reduce((sum, t) => sum + (t.target || 0), 0);

  if (loading) return (
    <div className="container-fluid py-4">
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Caricamento...</span>
        </div>
        <p className="mt-3">Caricamento evento...</p>
      </div>
    </div>
  );
  
  if (err) return (
    <div className="container-fluid py-4">
      <div className="alert alert-danger">{err}</div>
    </div>
  );
  
  if (!event) return null;

  // ✅ MAIN RENDER CON LAYOUT PULITO
  return (
    <div className="container-fluid py-4">
      {/* ✅ HEADER CON NAVIGAZIONE */}
      <div className="card mb-4">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <button 
              className="btn btn-outline-secondary"
                onClick={() => {
                  window.location.href = '/event-manager';
                }}
            >
              <i className="bi bi-arrow-left"></i> Torna agli Eventi
            </button>
            <div className="text-center">
              <h2 className="mb-0">{event.event_name}</h2>
              <p className="text-muted mb-0">
                {new Date(event.event_date).toLocaleDateString("it-IT")}
              </p>
            </div>
            <div style={{ width: '150px' }}></div>
          </div>
        </div>
      </div>
      <div className="card mb-4">
        <div className="card-body">
          <h5 className="card-title">Dettagli Evento</h5>
          
          <div className="mb-3">
            <label className="form-label">Nome Evento</label>
            {user.role === "admin" ? (
              <input
                type="text"
                className="form-control"
                value={editedEvent.event_name || ''}
                onChange={(e) => handleEventChange('event_name', e.target.value)}
              />
            ) : (
              <p className="form-control-plaintext">{event.event_name}</p>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Data</label>
            {user.role === "admin" ? (
              <input
                type="date"
                className="form-control"
                value={editedEvent.event_date || ''}
                onChange={(e) => handleEventChange('event_date', e.target.value)}
              />
            ) : (
              <p className="form-control-plaintext">
                {new Date(event.event_date).toLocaleDateString("it-IT")}
              </p>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Target Partecipanti</label>
            {user.role === "admin" ? (
              <input
                type="number"
                className="form-control"
                value={editedEvent.target_participants || 0}
                onChange={(e) => handleEventChange('target_participants', e.target.value)}
                min="0"
              />
            ) : (
              <p className="form-control-plaintext">{event.target_participants}</p>
            )}
          </div>

          {user.role === "admin" && eventChanged && (
            <button 
              className="btn btn-primary"
              onClick={handleSaveEvent}
            >
              Salva Modifiche Evento
            </button>
          )}
        </div>
      </div>


      {/* ✅ STATISTICHE CONFERMATI */}
      <div className="card mb-4 border-success">
        <div className="card-body text-center">
          <h5 className="text-success mb-0">
            Partecipanti confermati: <strong>{confirmedCount}</strong> / {clients.length}
          </h5>
        </div>
      </div>

      {/* ✅ OBIETTIVI PER AREA */}
      <div className="card mb-4">
        <div className="card-header bg-light">
          <button
            className="btn btn-outline-secondary w-100"
            onClick={() => setShowTargets(!showTargets)}
          >
            {showTargets ? "▼ Nascondi obiettivi area" : "▶ Obiettivi partecipanti per area"}
          </button>
        </div>
        {showTargets && (
          <div className="card-body">
            <AreaTargetsTable
              targets={targets}
              areas={areas}
              onUpdate={async (newTargets) => {
                try {
                  const res = await api.setEventAreaTargets(event.id, newTargets);
                  if (res.success) await loadTargets();
                  else alert("Errore aggiornamento obiettivi");
                } catch (err) {
                  alert("Errore di connessione");
                }
              }}
            />
          </div>
        )}
      </div>

      {/* ✅ TABELLA STATO PER AREA */}
      <div className="card mb-4">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">Stato Obiettivi per Area</h5>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-sm mb-0">
              <thead className="table-light">
                <tr>
                  <th>Area</th>
                  <th style={{ width: "120px" }}>Obiettivo</th>
                  <th style={{ width: "100px" }}>Raggiunti</th>
                  <th style={{ width: "120px" }}>Stato</th>
                </tr>
              </thead>
              <tbody>
                {areaCounts.map((ac) => (
                  <tr key={ac.name}>
                    <td><strong>{ac.name}</strong></td>
                    <td className="text-center">{ac.target}</td>
                    <td className="text-center">
                      <span className={ac.actual >= ac.target ? "badge bg-success" : "badge bg-warning"}>
                        {ac.actual}
                      </span>
                    </td>
                    <td className="text-center">
                      {ac.actual < ac.target ? (
                        <span className="text-danger">-{ac.target - ac.actual}</span>
                      ) : (
                        <span className="text-success">✓ Raggiunto</span>
                      )}
                    </td>
                  </tr>
                ))}
                <tr className="table-light">
                  <td><strong>TOTALE</strong></td>
                  <td className="text-center"><strong>{totalTarget}</strong></td>
                  <td className="text-center"><strong>{clients.length}</strong></td>
                  <td className="text-center">
                    {clients.length < totalTarget ? (
                      <span className="text-danger"><strong>-{totalTarget - clients.length}</strong></span>
                    ) : (
                      <span className="text-success"><strong>✓ Completato</strong></span>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ✅ FORM AGGIUNGI CLIENTE (solo admin) */}
      {user.role === "admin" && (
        <div className="card mb-4">
          <div className="card-header bg-success text-white">
            <h5 className="mb-0">Aggiungi Nuovo Partecipante</h5>
          </div>
          <div className="card-body">
            <form onSubmit={handleAddClient}>
              <div className="row g-3">
                <div className="col-md-2">
                  <label className="form-label">Nome</label>
                  <input
                    className="form-control"
                    name="first_name"
                    placeholder="Nome"
                    value={newClient.first_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Cognome</label>
                  <input
                    className="form-control"
                    name="last_name"
                    placeholder="Cognome"
                    value={newClient.last_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Azienda</label>
                  <input
                    className="form-control"
                    name="company_name"
                    placeholder="Azienda"
                    value={newClient.company_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Email</label>
                  <input
                    className="form-control"
                    name="email"
                    type="email"
                    placeholder="Email"
                    value={newClient.email}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Area</label>
                  <select
                    className="form-select"
                    name="area"
                    value={newClient.area}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Seleziona</option>
                    {areas.map((a) => (
                      <option value={a.name} key={a.id}>{a.name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="mt-3">
                <button className="btn btn-success" type="submit">
                  <i className="bi bi-plus-circle"></i> Aggiungi Partecipante
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ✅ TABELLA PARTECIPANTI */}
      <div className="card">
        <div className="card-header bg-info text-white">
          <h5 className="mb-0">Elenco Partecipanti ({clients.length})</h5>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-sm table-bordered align-middle mb-0">
              <thead className="table-primary">
                <tr>
                  <th className="d-none d-md-table-cell">Nome</th>
                  <th className="d-none d-md-table-cell">Cognome</th>
                  <th>Azienda</th>
                  <th className="d-none d-md-table-cell">Email</th>
                  <th>Area</th>
                  <th className="col-select-min-width">Stato</th>
                  {user.role === "admin" && (
                    <th style={{ width: "120px" }}>Azioni</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {clients.length === 0 ? (
                  <tr>
                    <td colSpan={user.role === "admin" ? 7 : 6} className="text-center text-muted">
                      Nessun partecipante
                    </td>
                  </tr>
                ) : (
                  clients.map((c) => {
                    const edited = editingRows[c.id] || {};
                    return (
                      <tr key={c.id}>
                        <td className="d-none d-md-table-cell">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={edited.first_name !== undefined ? edited.first_name : c.first_name}
                            onChange={e => handleEditChange(c.id, "first_name", e.target.value)}
                            readOnly={user.role !== "admin"}
                          />
                        </td>
                        <td className="d-none d-md-table-cell">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={edited.last_name !== undefined ? edited.last_name : c.last_name}
                            onChange={e => handleEditChange(c.id, "last_name", e.target.value)}
                            readOnly={user.role !== "admin"}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={edited.company_name !== undefined ? edited.company_name : c.company_name}
                            onChange={e => handleEditChange(c.id, "company_name", e.target.value)}
                            readOnly={user.role !== "admin"}
                          />
                        </td>
                        <td className="d-none d-md-table-cell">
                          <input
                            type="email"
                            className="form-control form-control-sm"
                            value={edited.email !== undefined ? edited.email : c.email}
                            onChange={e => handleEditChange(c.id, "email", e.target.value)}
                            readOnly={user.role !== "admin"}
                          />
                        </td>
                        <td>
                          <select
                            className="form-select form-select-sm"
                            value={edited.area !== undefined ? edited.area : c.area}
                            onChange={e => handleEditChange(c.id, "area", e.target.value)}
                            disabled={user.role !== "admin"}
                          >
                            {areas.map(a => (
                              <option key={a.id} value={a.name}>{a.name}</option>
                            ))}
                          </select>
                        </td>
                        <td className="col-select-min-width">
                          <select
                            className="form-select form-select-sm"
                            value={edited.status !== undefined ? edited.status : c.status}
                            onChange={e => handleEditChange(c.id, "status", e.target.value)}
                            disabled={user.role !== "admin"}
                          >
                            <option value="assigned">Assigned</option>
                            <option value="visited">Visited</option>
                            <option value="invited">Invited</option>
                            <option value="confirmed">Confirmed</option>
                            <option value="rejected">Rejected</option>
                          </select>
                        </td>
                        {user.role === "admin" && (
                          <td>
                            {isRowChanged(c) && (
                              <button
                                className="btn btn-outline-primary btn-sm w-100 mb-1"
                                onClick={() => handleRowSave(c.id)}
                              >
                                ✓ Salva
                              </button>
                            )}
                            <button
                              type="button"
                              className="btn btn-danger btn-sm w-100"
                              onClick={() => handleDeleteClient(c.id)}
                            >
                              Rimuovi
                            </button>
                          </td>
                        )}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventDetails;